import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from "parse";
import Api from "../../Utils/api";
import Utils from "../../Utils/Utility";
import Toggle from 'material-ui/Toggle';
import moment from 'moment-timezone';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


export default class OnlineOrdering extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            isOnlineOrderingEnabled:false,
            OODateTimeView:"",
            OnlineOrderingStopped:false,
            isDeliveryServiceEnabled:false,
            isCurbSidePickUpEnabled:false,
            askForGuestCount: false,
            isDineInServiceEnabled:false,
            isServiceFeeEnabled: false,
            DSDateTimeView:"",
            DeliveryServiceStopped:false,
            errors: {},
            isLoaded: true,
            activeLocation:'',
            timeZone:'',
            startDateOnlineService:this.loadLocationDateTime(),
            startDateDeliveryService:this.loadLocationDateTime(),
            isFocusOnlineInput:false,
            isFocusDeliveryInput:false,
            isBtnDisabled:true,
            IsOpenOnlineCalendar:true,
            IsOpenDeliveryCalendar:true,
            isServiceTypeInPercentage: false,
            serviceFeeValue: "",
            isPercentToggled: true,
            fields: {}
        }

        this._bind(
            'handleChangeToggleOnlineOrdering',
            'handleChangeToggleDeliveryService',
            'toggleCurbSidePickUp',
            'toggleDineInService',
            'handleChangeOnlineService',
            'handleChangeDeliveryService',
            'handleCancel',
            'loadLocationDateTime',
            'updateDineInLocation'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {
        this.loadLocationDateTime();
    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation
        },()=>{
            this.loadOnlineOrderingConfig();
        });

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null && nextProps.isLoaded == true) {

            this.setState({
                    activeLocation: nextProps.activeLocation
                },
                () => {
                    this.loadOnlineOrderingConfig();
                });
        }

    }

    /*  Set default timezone on moment  */
    loadLocationDateTime(){

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);
        moment.tz.setDefault(timeZone);
        return moment();

    }

    loadOnlineOrderingConfig() {

        let activeLocation = this.state.activeLocation;

        let timeZone = Utils.extractTimeZoneFromLocation(activeLocation);

        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);
        let defaultFromDate = new Date(currentDateTime);

        let self = this;

        // Online Ordering Enable/Disable View
        if (!Utils.isEmpty(activeLocation.stopOOUntil) && activeLocation.stopOOUntil != undefined) {

            let stopOOUntil = activeLocation.stopOOUntil.iso;


            let dateFromLT = Utils.formatDateTimeWithTimeZone(new Date(stopOOUntil),timeZone);
            let dateFromLTObject = new Date(dateFromLT);

            let ooEnabled = true;
            let onlineOrderingStopped = false;
            let OODateTime;
            // compare the current time


            if(defaultFromDate.getTime() > dateFromLTObject.getTime()){
                ooEnabled = true;
                onlineOrderingStopped = false;
                OODateTime = "";
            }
            else {
                ooEnabled = false;
                onlineOrderingStopped=true;
                OODateTime = dateFromLT;
            }

            self.setState({
                timeZone:timeZone,
                isOnlineOrderingEnabled:ooEnabled,
                OnlineOrderingStopped:onlineOrderingStopped,
                OODateTimeView:OODateTime,
                startDateOnlineService:null,
                isFocusOnlineInput:true,
                IsOpenOnlineCalendar:true
            });

        }else {
            self.setState({
                timeZone:timeZone,
                isOnlineOrderingEnabled:true,
                OnlineOrderingStopped:false,
                OODateTimeView:"",
                isFocusOnlineInput:true,
                IsOpenOnlineCalendar:true
            });
        }

        // Delivery Service View
        if (!Utils.isEmpty(activeLocation.stopDeliveryUntil) && activeLocation.stopDeliveryUntil != undefined) {

            let stopDeliveryUntil = activeLocation.stopDeliveryUntil.iso;

            let dateFromLT = Utils.formatDateTimeWithTimeZone(new Date(stopDeliveryUntil),timeZone);
            let dateFromLTObject = new Date(dateFromLT);
            let dsEnabled = true;
            let deliveryServiceStopped = false;
            let dsDateTime;
            // compare the current time
            if(defaultFromDate.getTime() > dateFromLTObject.getTime()){
                dsEnabled = true;
                deliveryServiceStopped = false;
                dsDateTime = "";
            }
            else {
                dsEnabled = false;
                deliveryServiceStopped = true;
                dsDateTime = dateFromLT;
            }



            self.setState({
                timeZone:timeZone,
                isDeliveryServiceEnabled:dsEnabled,
                DeliveryServiceStopped:deliveryServiceStopped,
                DSDateTimeView:dsDateTime,
                startDateDeliveryService: null,
                isFocusDeliveryInput:true,
                IsOpenDeliveryCalendar:true
            });

        }else {
            self.setState({
                timeZone:timeZone,
                isDeliveryServiceEnabled:true,
                DeliveryServiceStopped:false,
                DSDateTimeView:"",
                isFocusDeliveryInput:true,
                IsOpenDeliveryCalendar:true
            });
        }


        // Curbside Pickup
        if (!Utils.isEmptyObj(activeLocation.curbsidePickup)) {
            const isCurbsidePickup = activeLocation.curbsidePickup && activeLocation.curbsidePickup.enabled === true;
            self.setState(prevState => ({
                fields: {
                    ...prevState.fields,
                    curbsideInstructions: activeLocation.curbsidePickup.instructions
                },
                isCurbSidePickUpEnabled: isCurbsidePickup,
            }));
        }

        // Dine-In Service
        if (!Utils.isEmptyObj(activeLocation.dineIn)) {
            const isDineInServiceEnabled = activeLocation.dineIn && activeLocation.dineIn.enabled === true;
            const guestCount = this.state.askForGuestCount;
            const dineInJSON = activeLocation.dineIn;

            self.setState(prevState => ({
                fields: {
                    ...prevState.fields,
                    dineInObj: activeLocation.dineIn
                },
                isDineInServiceEnabled,
                askForGuestCount: dineInJSON.askGC
            }));
        }

        // Service Fee
        if (!Utils.isEmptyObj(activeLocation.serviceFee)) {
            const { feeType } = activeLocation.serviceFee;
            const isPercentToggled = feeType === "percentage";
            self.setState(prevState => ({
                fields: {
                    ...prevState.fields,
                    serviceFeeObj: activeLocation.serviceFee,
                },
                isServiceFeeEnabled: true,
                isPercentToggled
            }));
        } else {
            const serviceFeeObj = { fee: "", feeType: "percentage" };
            self.setState(prevState => ({
                fields: {
                    ...prevState.fields,
                    serviceFeeObj
                },
                isPercentToggled: true
            }));
        }

    }


    handleValidation(){

        let isOnlineOrderingEnabled = this.state.isOnlineOrderingEnabled;
        let isDeliveryServiceEnabled = this.state.isDeliveryServiceEnabled;
        let errors = {};
        let formIsValid = true;
        let isCurbSidePickUpEnabled = this.state.isCurbSidePickUpEnabled;
        let isServiceFeeEnabled = this.state.isServiceFeeEnabled;
        let isDineInServiceEnabled = this.state.isDineInServiceEnabled;
        let {curbsideInstructions, serviceFeeObj, dineInObj} = this.state.fields;

        let stopOOUntil = this.state.OODateTimeView;
        let ooDateTimes = this.state.startDateOnlineService;
        let stopDSUntil = this.state.DSDateTimeView;
        let DSDateTimes = this.state.startDateDeliveryService;

        let activeLocation = this.state.activeLocation;

        let timeZone = this.state.timeZone;
        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);
        let defaultFromDate = new Date(currentDateTime);

        if (!Utils.isEmpty(activeLocation.stopDeliveryUntil) && activeLocation.stopDeliveryUntil != undefined) {
            let stopDSUntilDelivery = activeLocation.stopDeliveryUntil.iso;
            let stopDs = Utils.formatDateTimeWithTimeZone(new Date(stopDSUntilDelivery), timeZone);
            let deliveryService = new Date(stopDs);

            if(defaultFromDate.getTime() > deliveryService.getTime()){
                if(isDeliveryServiceEnabled == false){
                    if(Utils.isEmpty(DSDateTimes )){
                        formIsValid = false;
                        errors["errors"] = "Please Enter Date & Time to Update Delivery Service";
                        this.setState({errors: errors}, () => {
                            Utils.scrollToTop("err-box");
                        });
                        return formIsValid;
                    }
                }

            }
        }


        if (!Utils.isEmpty(activeLocation.stopOOUntil) && activeLocation.stopOOUntil != undefined) {
            let stopOOUntilOnline = activeLocation.stopOOUntil.iso;

            let dateFromLT = Utils.formatDateTimeWithTimeZone(new Date(stopOOUntilOnline),timeZone);
            let onlineOrdering = new Date(dateFromLT);

            if(defaultFromDate.getTime() > onlineOrdering.getTime()){
                if(isOnlineOrderingEnabled == false){
                    if(Utils.isEmpty(ooDateTimes)){
                        formIsValid = false;
                        errors["errors"] = "Please Enter Date & Time to Update Online Ordering Service";
                        this.setState({errors: errors}, () => {
                            Utils.scrollToTop("err-box");
                        });
                        return formIsValid;
                    }
                }
            }
        }

        if(isDeliveryServiceEnabled == false){

            if (Utils.isEmpty(DSDateTimes) && Utils.isEmpty(stopDSUntil )){
                formIsValid = false;
                errors["errors"] = "Delivery Service date & time is required";
                this.setState({errors: errors}, () => {
                    Utils.scrollToTop("err-box");
                });
                return formIsValid;
            }

        }

        if(isOnlineOrderingEnabled == false){

           if (Utils.isEmpty(ooDateTimes) && Utils.isEmpty(stopOOUntil)){
               formIsValid = false;
               errors["errors"] = "Online Ordering date & time is required";
               this.setState({errors: errors}, () => {
                   Utils.scrollToTop("err-box");
               });
               return formIsValid;
           }
        }


        // Validate curbside pickup instructions if enabled
        if (isCurbSidePickUpEnabled && Utils.isEmpty(curbsideInstructions)) {
            errors["curbsideInstructions"] = "Instructions cannot be empty";
            formIsValid = false;
            // Set errors state and scroll to top of the corresponding section
            this.setState({ errors }, () => {
                Utils.scrollToTop("toggleCurbSide");
            });

            return formIsValid;
        }

        // Validate Dine-In Service
        if (isDineInServiceEnabled) {
            const { serviceLocation, instructions } = dineInObj || {};
            if (Utils.isEmpty(serviceLocation)) {
                errors["serviceLocation"] = "Service location cannot be empty";
                formIsValid = false;
                this.setState({ errors }, () => {
                    Utils.scrollToTop("toggleDineIn");
                });
                return formIsValid; // Exit early if error occurs
            }
            if (Utils.isEmpty(instructions)) {
                errors["instructions"] = "Dine-In service instructions cannot be empty";
                formIsValid = false;
                this.setState({ errors }, () => {
                    Utils.scrollToTop("toggleDineIn");
                });
                return formIsValid; // Exit early if error occurs
            }
        }

        // Validate Service Fee
        if (isServiceFeeEnabled && Utils.isEmpty(serviceFeeObj.fee)) {
            errors["fee"] = "Service fee cannot be empty";
            formIsValid = false;
            this.setState({ errors }, () => {
                Utils.scrollToTop("toggleServiceFee");
            });
            return formIsValid; // Exit early if error occurs
        }

        // Reset errors if no validation error occurred
        if (formIsValid) {
            errors = {};
            this.setState({ errors });
        }

        return formIsValid;
    }

    getUTCDateTimeJSONFromSelectedDateTime(startDateTime){
        var format = 'YYYY/MM/DD HH:mm:ss';
        var dateStringWithTime = moment(startDateTime).format(format);

        var utcDateTime = moment(dateStringWithTime, format).tz("UTC").format();

        return Utils.getDateJson(utcDateTime);
    }

    updateOnlineOrderingFormSubmit(e){
        e.preventDefault();

        if(this.handleValidation()){

            let activeLocation = this.state.activeLocation;
            let locId = activeLocation.objectId;
            let isCurbSidePickUpEnabled = this.state.isCurbSidePickUpEnabled;
            let isServiceFeeEnabled = this.state.isServiceFeeEnabled;
            let isDineInServiceEnabled = this.state.isDineInServiceEnabled;
            let fields = this.state.fields;

            let self = this;
            self.setState({
                isLoaded : false,
                errors: {}
            });

            let parameterObject = {};

            // Online Ordering Enable/Disable
            let isOnlineOrderingEnabled = this.state.isOnlineOrderingEnabled;
            if(isOnlineOrderingEnabled == false){

                let newDateTimeOnlineOrdering = this.state.startDateOnlineService;

                if(!Utils.isEmpty(newDateTimeOnlineOrdering)){
                    let stopOOUntilJSON = self.getUTCDateTimeJSONFromSelectedDateTime(newDateTimeOnlineOrdering);
                    parameterObject["stopOOUntil"] = stopOOUntilJSON
                }

            }
            else {

                parameterObject["stopOOUntil"] = {"__op" : "Delete"};

            }

            // Online Ordering Enable/Disable
            let isDeliveryServiceEnabled = this.state.isDeliveryServiceEnabled;
            if(isDeliveryServiceEnabled == false){

                let newDateTimeDeliveryService = this.state.startDateDeliveryService;
                if(!Utils.isEmpty(newDateTimeDeliveryService)){
                    let stopDeliveryUntilJSON = self.getUTCDateTimeJSONFromSelectedDateTime(newDateTimeDeliveryService);
                    parameterObject["stopDeliveryUntil"] = stopDeliveryUntilJSON;
                }
            }
            else {
                parameterObject["stopDeliveryUntil"] = {"__op" : "Delete"};
            }


            let curbsideInstructions = this.state.fields.curbsideInstructions;
            if(isCurbSidePickUpEnabled){
                // Update the curbSidePickup object with the instructions
                const updatedCurbSidePickup = {
                    ...activeLocation.curbsidePickup, // Spread existing curbSidePickup object
                    instructions: curbsideInstructions, // Update instructions
                    enabled: isCurbSidePickUpEnabled
                };

                // Update parameterObject with the updated curbSidePickup
                parameterObject["curbsidePickup"] = updatedCurbSidePickup;
            }else {
                const updatedCurbSidePickup = {
                    ...activeLocation.curbsidePickup, // Spread existing curbSidePickup object
                    instructions: !Utils.isEmpty(curbsideInstructions) ? curbsideInstructions : "" ,
                    enabled: false// Update instructions
                };

                // Update parameterObject with the updated curbSidePickup
                parameterObject["curbsidePickup"] = updatedCurbSidePickup;

            }

            if(isDineInServiceEnabled){
                let dineInObj = this.state.fields.curbsideInstructions;
                let serviceLocation = this.state.fields.dineInObj.serviceLocation;
                let instructions = this.state.fields.dineInObj.instructions;
                let gc = this.state.askForGuestCount;

                const updatedDineInObj = {
                    ...activeLocation.dineIn, // Spread existing curbSidePickup object
                    serviceLocation: serviceLocation,// Update instructions
                    instructions: instructions,
                    enabled: isDineInServiceEnabled,
                    askGC: gc
                };


                // Update parameterObject with the updated dineInObj
                parameterObject["dineIn"] = updatedDineInObj;

            }else {

                const updatedDineInObj = {
                    ...activeLocation.dineIn, // Spread existing curbSidePickup object
                    enabled: false
                };


                // Update parameterObject with the updated dineInObj
                parameterObject["dineIn"] = updatedDineInObj;
            }

            if (isServiceFeeEnabled) {
                let { serviceFeeObj } = this.state.fields;
                let { fee, minAmount, desc } = serviceFeeObj;
                let isPercentToggled = this.state.isPercentToggled;

                const feeType = isPercentToggled ? "percentage" : "fixed";

                let updatedServiceFeeObj = {
                    ...activeLocation.serviceFee,
                    fee,
                    minAmount: Utils.isEmpty(minAmount) ? 0 : minAmount,
                    desc: Utils.isEmpty(desc) ? "" : desc,
                    feeType
                };


                // Update parameterObject with the updated updatedServiceFeeObj
                parameterObject["serviceFee"] = updatedServiceFeeObj;

            }
            else {

                parameterObject["serviceFee"] = {"__op" : "Delete"};

            }

            // add the location id in objectId key
            parameterObject["objectId"] = locId;
            this.updateOnlineOrderingConfig(parameterObject);
        }
    }

    updateOnlineOrderingConfig(paramsObject){

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;

        let activeLocation = this.state.activeLocation;
        let locId = activeLocation.objectId;
        let self = this;

        Api.updateLocation(userId, sessionToken, bizId, locId, paramsObject)
            .then(
                (result) => {
                    const response = result.data;

                    alert("Online Ordering config are updated successfully");

                    self.setState({
                        isLoaded: true,
                        isBtnDisabled:true
                    });


                    // Reload the data
                    self.props.reloadLocation();

                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    this.setState({isLoaded: true});
                    console.log("Error occured while fetching latest user data!");
                }
            );

    }


    handleChangeOnlineService(date) {

        this.showOODateTimeView(date);

        let newDate = date.format('MM-DD-YYYY');
        let currentDayDate = moment().format('MM-DD-YYYY');

        //return true if selected date is same as today
        if(moment(newDate).isSame(currentDayDate)){
            this.setState({
                IsOpenOnlineCalendar:true,
                isBtnDisabled:false
            })
        }else{
            this.setState({
                IsOpenOnlineCalendar:false,
                isBtnDisabled:false
            })
        }

    }

    handleChangeDeliveryService(date) {

        this.showDSDateTimeView(moment(date,this.state.timeZone));

        let newDate = date.format('MM-DD-YYYY');
        let currentDayDate = moment().format('MM-DD-YYYY');

        //return true if selected date is same as today
        if(moment(newDate).isSame(currentDayDate)){
            this.setState({
                IsOpenDeliveryCalendar:true,
                isBtnDisabled:false
            })
        }else{
            this.setState({
                IsOpenDeliveryCalendar:false,
                isBtnDisabled:false
            })
        }

    }

    showOODateTimeView(momentDateTime){

        if (this.state.isOnlineOrderingEnabled == false){

            this.setState({
                startDateOnlineService : momentDateTime,
            })
        }


    }

    showDSDateTimeView(momentDateTimes){

        if (this.state.isDeliveryServiceEnabled == false){

            this.setState({
                startDateDeliveryService: momentDateTimes
            })
        }

    }

    handleChangeToggleOnlineOrdering = (event, eventValue) => {

        this.setState({
            isOnlineOrderingEnabled: eventValue,
            startDateOnlineService:null,
            isFocusOnlineInput:true,
            isBtnDisabled:false,
            errors:"",
            IsOpenOnlineCalendar:true

        });
    };

    handleChangeToggleDeliveryService = (event, eventValue) => {

        this.setState({
            isDeliveryServiceEnabled: eventValue,
            startDateDeliveryService:null,
            isFocusDeliveryInput:true,
            isBtnDisabled:false,
            errors:"",
            IsOpenDeliveryCalendar:true
        });

    };

    toggleCurbSidePickUp = (event, eventValue) => {

        this.setState({
            isCurbSidePickUpEnabled: eventValue,
            isBtnDisabled:false,
            errors:{},
        });

    };

    toggleDineInService = (event, eventValue) => {

        this.setState({
            isDineInServiceEnabled: eventValue,
            isBtnDisabled:false,
            errors:{},
        });

    };

    handleGuestCountChange = (event, eventValue) => {
        this.setState({
            askForGuestCount: eventValue,
            isBtnDisabled:false,
            errors:{}
        });
    };

    toggleServiceFee = (event, eventValue) => {

        this.setState({
            isServiceFeeEnabled: eventValue,
            isBtnDisabled:false,
            errors:{}
        });

    };


    updateDineInLocation(field, e) {
        const val = e.target.value;

        // Update the dineInObj based on the provided field
        const updatedDineInObj = {
            ...this.state.fields.dineInObj,
            [field]: val
        };

        // Update the fields object with the updated dineInObj
        this.setState(prevState => ({
            fields: {
                ...prevState.fields,
                dineInObj: updatedDineInObj
            },
            isBtnDisabled:false,
            errors: {} // Clear errors if any
        }));
    }

    updateServiceFeeValue(field, e) {
        const val = e.target.value;

        // Update the serviceFeeObj based on the provided field
        const updatedServiceFeeObj = {
            ...this.state.fields.serviceFeeObj,
            [field]: val
        };

        // Update the fields object with the updated serviceFeeObj
        this.setState(prevState => ({
            fields: {
                ...prevState.fields,
                serviceFeeObj: updatedServiceFeeObj
            },
            isBtnDisabled:false,
            errors: {} // Clear errors if any
        }));
    }

    setPercentToggle = (field, e) => {
        const isPercentToggled = field === "percentage";

        this.setState({
            isPercentToggled,
            isBtnDisabled: false,
            errors: {},
        });
    };


    handleCancel(){
        this.props.reloadLocation();
        this.setState({
            errors:"",
            isBtnDisabled:true
        });
    };

    updateCurbsideInstructions(e){
        let val = e.target.value;

        this.setState(prevState => ({
            fields: {
                ...prevState.fields,
                curbsideInstructions:  val
            },
            isBtnDisabled:false,
            errors: {}
        }));
    }

    render() {

        const { isPercentToggled } = this.state;

        // let formattedValue = serviceFeeValue;
        const feeFormatType = isPercentToggled ? "Percentage" : "Fixed";


        return (
            <div className="order-notification">
                {!this.state.isLoaded ? <Spinner/> : null}
                {
                    this.state.errors["errors"] ? (
                        <div className="alert alert-danger text-center" role="alert" id={"err-box"}>
                            <span className="form-text">{this.state.errors["errors"]}</span>
                        </div>) : null

                }
                <div className="border-class marginTop">
                    <h4 id="translations" className="page-header">Update Online Ordering Settings</h4>
                    <form name="updateLocationForm" className="updateLocationForm"
                          onSubmit={this.updateOnlineOrderingFormSubmit.bind(this)}>
                        <div className="row form-group">

                            <div className="col-lg-12">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputPassword1">Online Ordering</label>
                                        <Toggle
                                            id={"isOnlineOrderingEnabled"}
                                            defaultToggled={this.state.isOnlineOrderingEnabled}
                                            onToggle={this.handleChangeToggleOnlineOrdering}
                                            style={{marginTop: 5, width:'100px'}}
                                            thumbSwitchedStyle={{ backgroundColor: '#008000'}}
                                            trackSwitchedStyle={{ backgroundColor: '#8fbc8f'}}
                                        />

                                    </div>

                                    <div className="row col-lg-12">
                                        Online Ordering is <b>{this.state.isOnlineOrderingEnabled ? "ACTIVE" : "DISABLED"}</b>
                                    </div>

                                    {
                                        this.state.OODateTimeView && this.state.isOnlineOrderingEnabled == false ? (
                                            <h5>
                                                <b className={"dateview-container"}>Until {this.state.OODateTimeView}</b>
                                            </h5>
                                        ) : null
                                    }

                                    {
                                        this.state.isOnlineOrderingEnabled == false ? (
                                            <div className="row">

                                                <div className="col-lg-12  date-jump">
                                                    <i className="fa fa-online fa-calendar"></i>
                                                    <DatePicker
                                                        selected={this.state.startDateOnlineService}
                                                        onChange={this.handleChangeOnlineService}
                                                        minDate={moment()}
                                                        minTime={this.state.IsOpenOnlineCalendar ? moment() : moment().set({
                                                            h: 0,
                                                            m: 0
                                                        })}
                                                        maxTime={moment().set({h: 23, m: 45})}
                                                        showTimeSelect
                                                        dateFormat="LLL"
                                                        placeholderText={"Choose the Date Time"}
                                                        onChangeRaw={(e) => e.preventDefault()}
                                                        timeIntervals={30}
                                                        autoFocus={this.state.isFocusOnlineInput}
                                                        shouldCloseOnSelect={false}
                                                        onFocus={(e) => e.target.readOnly = true}

                                                    >

                                                        <div
                                                            className="title-container-new align-items-center justify-content-center">

                                                            {this.state.OODateTimeView && this.state.isOnlineOrderingEnabled == false ? (
                                                                <div>
                                                                    <span
                                                                        className="online-ordering-until">Online Ordering is STOPPED Until <br/></span>
                                                                    <span
                                                                        className="Online-dateTime-view">{this.state.OODateTimeView}</span>
                                                                </div>

                                                            ) : <div className="container-datetime">
                                                                <span> Choose the Date & Time </span>
                                                            </div>
                                                            }

                                                        </div>
                                                    </DatePicker>




                                                </div>
                                            </div>
                                        ) : null
                                    }
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group exampleInput">
                                        <label htmlFor="exampleInputPassword1">Delivery Service</label>
                                        <Toggle
                                            id={"isDeliveryServiceEnabled"}
                                            defaultToggled={this.state.isDeliveryServiceEnabled}
                                            onToggle={this.handleChangeToggleDeliveryService}
                                            style={{marginTop: 5, width:'100px'}}
                                            thumbSwitchedStyle={{ backgroundColor: '#008000'}}
                                            trackSwitchedStyle={{ backgroundColor: '#8fbc8f'}}
                                        />
                                    </div>

                                    <div className="row col-lg-12">
                                        Delivery Service is <b>{this.state.isDeliveryServiceEnabled ? "ACTIVE" : "DISABLED"}</b>
                                    </div>

                                    {
                                        this.state.DSDateTimeView && this.state.isDeliveryServiceEnabled == false ? (
                                            <h5>
                                                <b className={"dateview-container"}>Until {this.state.DSDateTimeView}</b>
                                            </h5>
                                        ) : null
                                    }

                                    {
                                        this.state.isDeliveryServiceEnabled == false ? (
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <i className="fa fa-online fa-calendar"></i>
                                                    <DatePicker
                                                        selected={this.state.startDateDeliveryService}
                                                        onChange={this.handleChangeDeliveryService}
                                                        minDate={moment()}
                                                        minTime={this.state.IsOpenDeliveryCalendar ? moment() : moment().add(1, 'days').set({
                                                            h: 0,
                                                            m: 0
                                                        })}
                                                        maxTime={moment().set({h: 23, m: 45})}
                                                        showTimeSelect
                                                        dateFormat="LLL"
                                                        placeholderText={"Choose the Date Time"}
                                                        timeIntervals={30}
                                                        onChangeRaw={(e) => e.preventDefault()}
                                                        preventOpenOnFocus
                                                        autoFocus={this.state.isFocusDeliveryInput}
                                                        onFocus={(e) => e.target.readOnly = true}
                                                        shouldCloseOnSelect={false}
                                                    >

                                                        <div
                                                            className="title-container-new align-items-center justify-content-center">

                                                            {this.state.DSDateTimeView && this.state.isDeliveryServiceEnabled == false ? (
                                                                <div>
                                                                <span
                                                                    className="online-ordering-until">Delivery Service is STOPPED Until <br/></span>
                                                                    <span
                                                                        className="Online-dateTime-view">{this.state.DSDateTimeView}</span>
                                                                </div>

                                                            ) : <div className="container-datetime">
                                                                <span> Choose the Date & Time </span>
                                                            </div>
                                                            }

                                                        </div>
                                                    </DatePicker>
                                                </div>
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>

                            <hr />

                            <div className="col-lg-12">
                                <div id="translations" className="page-header"></div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputPassword1">Curbside Pickup</label>
                                        <Toggle
                                            id={"isOnlineOrderingEnabled"}
                                            defaultToggled={this.state.isCurbSidePickUpEnabled}
                                            onToggle={this.toggleCurbSidePickUp}
                                            style={{marginTop: 5, width:'100px'}}
                                            thumbSwitchedStyle={{ backgroundColor: '#008000'}}
                                            trackSwitchedStyle={{ backgroundColor: '#8fbc8f'}}
                                        />

                                    </div>

                                    { this.state.isCurbSidePickUpEnabled ? (
                                        <div className={"toggleCurbSide"} id={"toggleCurbSide"}>
                                            <h5><b>Customer Instructions</b></h5>
                                            <span>These Instructions are visible to the customer when placing curbside order.</span>

                                            <div className="mt-10">
                                                 <textarea
                                                     style={{height: "15vh"}}
                                                     className="form-control light-border"
                                                     name="cOptionDescription"
                                                     id="cOptionDescription"
                                                     ref="description" rows="1"
                                                     placeholder="Short Description"
                                                     onChange={this.updateCurbsideInstructions.bind(this)}
                                                     value={this.state.fields["curbsideInstructions"] || ""}
                                                 >
                                                </textarea>

                                                <span className={"d-block form-text"} style={{color: "red"}}>{this.state.errors["curbsideInstructions"]}</span>
                                            </div>

                                        </div>

                                    ): null}

                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group exampleInput">
                                        <label htmlFor="exampleInputPassword1">Dine-In Service</label>
                                        <Toggle
                                            id={"isDeliveryServiceEnabled"}
                                            defaultToggled={this.state.isDineInServiceEnabled}
                                            onToggle={this.toggleDineInService}
                                            style={{marginTop: 5, width:'100px'}}
                                            thumbSwitchedStyle={{ backgroundColor: '#008000'}}
                                            trackSwitchedStyle={{ backgroundColor: '#8fbc8f'}}
                                        />
                                    </div>

                                    { this.state.isDineInServiceEnabled ? (
                                        <div className={"toggleCurbSide"} id={"toggleDineIn"}>
                                            <div>
                                                <h5><b>Service Location</b></h5>
                                                <span>Service location where the food will be served. For ex: Room Number, Table Number.</span>

                                                <div className="form-group mt-10">
                                                    <input type="text" className="form-control light-border" id="storeId"
                                                           ref="storeId"
                                                           aria-describedby="storeId"
                                                           placeholder="Enter the Room Number"
                                                           value={this.state.fields["dineInObj"] ? this.state.fields["dineInObj"]["serviceLocation"] : ""}
                                                           onChange={(e) => this.updateDineInLocation("serviceLocation", e)}
                                                    />
                                                    <span style={{color: "red"}} className="form-text mt-5">{this.state.errors["serviceLocation"]}
                                                    </span>
                                                </div>
                                            </div>

                                            <div>
                                                <h5><b>Dine-In Instructions</b></h5>
                                                <span>These instructions are visible to the customer when placing Dine-In order.</span>

                                                <div className="form-group mt-10">
                                                    <textarea
                                                        style={{height: "15vh"}}
                                                        className="form-control light-border"
                                                        name="cOptionDescription"
                                                        id="cOptionDescription"
                                                        ref="description" rows="1"
                                                        placeholder="Short Description"
                                                        onChange={(e) => this.updateDineInLocation("instructions", e)}
                                                        value={this.state.fields["dineInObj"] ? this.state.fields["dineInObj"]["instructions"] : ""}
                                                    >

                                                    </textarea>

                                                    <span style={{color: "red"}} className="form-text mt-5">{this.state.errors["instructions"]}
                                                    </span>
                                                </div>
                                            </div>

                                            <div>
                                                <span><b>Ask guest count</b></span>
                                                <Toggle
                                                    className={"display-inline-block pull-right"}
                                                    id={"isGuestCount"}
                                                    defaultToggled={this.state.askForGuestCount}
                                                    onToggle={this.handleGuestCountChange}
                                                    style={{marginTop: 5, width:'100px'}}
                                                    thumbSwitchedStyle={{ backgroundColor: '#008000'}}
                                                    trackSwitchedStyle={{ backgroundColor: '#8fbc8f'}}
                                                />

                                                <span className={"d-block mt-10"}>Customers will be prompted to enter guest count when placing Dine-
                                                In order.</span>


                                            </div>

                                        </div>

                                    ): null}

                                </div>
                            </div>

                            <div className="col-lg-12 ">
                                <div id="translations" className="page-header"></div>
                                <div className="col-lg-6">

                                    <div className={"toggleCurbSide"}>
                                        <div>
                                            <h5><b>SERVICE FEE (Pickup & Delivery orders)</b></h5>
                                            <div className="form-group">
                                                <span className={"display-inline-block"}>Service Fee is <b>{this.state.isServiceFeeEnabled ? "Enabled" : "Disabled"}</b>.</span>
                                                <Toggle
                                                    className={"display-inline-block pull-right" +
                                                        " guest-toggle"}
                                                    id={"isGuestCount"}
                                                    defaultToggled={this.state.isServiceFeeEnabled}
                                                    onToggle={this.toggleServiceFee}
                                                    thumbSwitchedStyle={{ backgroundColor: '#008000'}}
                                                    trackSwitchedStyle={{ backgroundColor: '#8fbc8f'}}
                                                />

                                            </div>

                                            { this.state.isServiceFeeEnabled ? (
                                                <div>
                                                    <div className="mt-20 d-block " id={"serviceFeeToggle"}>

                                                        <div className={"servicefee-container display-inline-block"}>
                                                            <label className={"d-block"}>Service Fee ({feeFormatType})</label>
                                                            <input
                                                                type="number"
                                                                onChange={(e) => this.updateServiceFeeValue("fee", e)}
                                                                className="form-control light-border display-inline-block"
                                                                id="storeId"
                                                                ref="storeId"
                                                                aria-describedby="storeId"
                                                                placeholder={"Service Fee"}
                                                                value={this.state.fields["serviceFeeObj"] ? this.state.fields["serviceFeeObj"]["fee"] : ""}
                                                            />
                                                        </div>

                                                        <div className={"display-inline-block " +
                                                            " servicefee-toggle " +
                                                            "cursor-pointer"}>

                                                            <div
                                                                className={`percent-toggle-container ${!Utils.isEmpty(this.state.errors["fee"]) ? "percent-container" : ""}`}
                                                            >
                                                                <btn
                                                                    className={`btn-toggle ${this.state.isPercentToggled ? "btn-toggle-active" : ""}`}
                                                                    onClick={(e) => this.setPercentToggle("percentage", e)}
                                                                >
                                                                    %
                                                                </btn>
                                                                <btn
                                                                    className={`btn-toggle ${!this.state.isPercentToggled ? "btn-toggle-active" : ""}`}
                                                                    onClick={(e) => this.setPercentToggle("fixed", e)}

                                                                >
                                                                    $
                                                                </btn>
                                                            </div>

                                                        </div>

                                                        <span
                                                            className={`d-block form-text" +
                                                            " servicefee-err-box ${!Utils.isEmpty(this.state.errors["fee"]) ? "error-percent-box" : ""}`}
                                                              style={{color: "red"}}
                                                        >
                                                            {this.state.errors["fee"]}
                                                        </span>

                                                    </div>

                                                    <div>
                                                        <div className="d-block min-box">
                                                            <label className={"d-block"}>Minimum Order Amount</label>
                                                            <input
                                                                type="number"
                                                                onChange={(e) => this.updateServiceFeeValue("minAmount", e)}
                                                                className="form-control light-border display-inline-block fee-input-container"
                                                                id="storeId"
                                                                ref="storeId"
                                                                aria-describedby="storeId"
                                                                placeholder={"Enter Minimum Order Amount"}
                                                                value={this.state.fields["serviceFeeObj"] ? this.state.fields["serviceFeeObj"]["minAmount"] : ""}
                                                            />

                                                            <span className={"d-block form-text"} style={{color: "red"}}>{this.state.errors["minAmount"]}</span>

                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div className="mt-20 d-block">
                                                            <label className={"d-block"}>Service Fee Description</label>
                                                            <input
                                                                type="text"
                                                                onChange={(e) => this.updateServiceFeeValue("desc", e)}
                                                                className="form-control light-border display-inline-block fee-input-container"
                                                                id="storeId"
                                                                ref="storeId"
                                                                aria-describedby="storeId"
                                                                placeholder={"Enter Fee Description"}
                                                                value={this.state.fields["serviceFeeObj"] ? this.state.fields["serviceFeeObj"]["desc"] : ""}
                                                            />

                                                            <span className={"d-block form-text"} style={{color: "red"}}>{this.state.errors["desc"]}</span>

                                                        </div>
                                                    </div>
                                                </div>

                                            ): null}
                                        </div>

                                    </div>

                                </div>
                            </div>


                        </div>
                        <hr></hr>

                        <div className="form-group">
                            <button type="submit"  className={this.state.isBtnDisabled ? "btn-save btn btn-export" : "btn btn-export"}>Save</button>
                            <button type="button" className="btn btn-default back-button"
                                onClick={this.handleCancel}>Cancel
                            </button>

                        </div>
                        <hr></hr>

                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/location/online-ordering.js